/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SettingsService } from '@ithinkdt/shared/browser';
import { BaseAjaxService } from '@ithinkdt/shared/http';

import { API } from './api';

@Injectable({ providedIn: 'root' })
export class LogoutService extends BaseAjaxService {
  private admin: any = this.settings.userConfig.env.serverName.admin;
  private logoutUrl: string = this.settings.userConfig.theme.logoutUrl || '';

  constructor(private settings: SettingsService, http: HttpClient) {
    super(http);
  }

  logout(): Observable<any> {
    const url = this.logoutUrl || API.logout;
    return this.post(this.admin + url);
  }
}
